<template>
    <div id="related-stories">
        <div class="row pb-5 w-100">
            <div class="col-md-12 text-center">
                <h1 class="wwf-font" style="font-size:3em;">RELATED STORIES</h1>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-4" v-for="story in related_stories" v-bind:key="story.id">
                    <a :href=story.slug>
                        <div class="card" style="width: 100%">
                            <div class="exclusive-tag" v-bind:class="{'d-none' : !story.exclusive}">HERO MEMBER EXCLUSIVE</div>
                            <img class="card-img-top" :src="'/storage/'+story.img" alt="Card image cap">
                            <div class="card-body">
                                <p class="story-title">{{story.title}}</p>
                                <p class="card-text">{{strip_html(story.body)}}</p>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 text-center mt-4"><a href="/stories" class="see-all-stories">See all</a></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                related_stories: []
            }
        },
        created(){
            this.fetchStories();
        },
        methods: {
            strip_html(value) {
                var div = document.createElement("div");
                div.innerHTML = value;
                var text = div.textContent || div.innerText || "";
                return text;
            },
            fetchStories(){
                fetch('/api/v1/stories/relatedstories')
                .then(res => res.json())
                .then(res => {
                    this.related_stories = res;
                })
                .catch(err => console.log(err))
            }
        }
    }
</script>

<style scoped>
    #related-stories{
        margin-top: 7rem;
    }
    .card{
        border:none !important;
        background-color: #F9F9F9 !important;
        margin-bottom: 10px !important;
    }
    .card .card-body{
        padding: 25px;
    }
    .card .card-text{
        font-size: 1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        color:black;
        text-decoration:none;
    }
    .card .story-title{
        font-size: 1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-bottom: 2px;
        color:black;
    }
    .exclusive-tag{
        position: absolute;
        top:0;
        background-color: #FFCA00;
        color:white;
        padding: 5px 10px;
        font-weight: 700;
    }
    .see-all-stories{
        border: 2px solid #f07d00;
        background-color: white;
        color: #f07d00;
        font-size: 1.2rem;
        padding-left: 20px;
        padding-right: 20px;
        font-weight: 700;
    }
</style>